module.exports = __webpack_public_path__ + "img/zhengcefagui.1bb93e19.jpg";